// Per-browser preferences in localStorage (touch mode, key maps, volume, game options). Every access is guarded:
// storage can be missing or throw (private mode, blocked site data), and the site must work without it.

export function loadPref<T>(key: string, fallback: T): T {
  try {
    const raw = globalThis.localStorage?.getItem(key);
    return raw === null || raw === undefined ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

export function savePref(key: string, value: unknown): void {
  try { globalThis.localStorage?.setItem(key, JSON.stringify(value)); } catch { /* not persisted */ }
}

export function deletePref(key: string): void {
  try { globalThis.localStorage?.removeItem(key); } catch { /* ignore */ }
}
